import React from "react";
import "./LineMaskHero.css";

function LineMaskHero() {
  return (
    <section className="hero-section">
      {/* Tło - 3 slajdy */}
      <div className="hero-slide"></div>
      <div className="hero-slide"></div>
      <div className="hero-slide"></div>

      {/* Większa animacja linii (SVG) */}
      <svg
        className="line-mask-svg"
        viewBox="0 0 400 200"
        preserveAspectRatio="none"
      >
        <path
          d="M 20,100 
             Q 200,0 380,100 
             Q 200,200 20,100 Z"
          stroke="#ffffff"
          strokeWidth="3"
          fill="none"
        />
      </svg>

      {/* Tekst */}
      <div className="hero-text">
        <h2>Witam w galerii</h2>
        <p>Zapraszam do zapoznania się z kolekcją!</p>
      </div>
    </section>
  );
}

export default LineMaskHero;
